import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { t } = useTranslation();

  const fullTitle = t('home.heroTitle', 'Navoiy Kompyuter Spektr ETM');
  
  const [displayedTitle, setDisplayedTitle] = useState('');

  useEffect(() => {
    let index = 0;
    const intervalId = setInterval(() => {
      if (index <= fullTitle.length) {
        setDisplayedTitle(fullTitle.slice(0, index));
        index += 1;
      } else {
        clearInterval(intervalId);
      }
    }, 75);
    return () => clearInterval(intervalId);
  }, [fullTitle]);

  // Fotogalereya rasmlari
  const galleryImages = [
    '/images/smartone1.jpg',
    '/images/smartone2.jpg',
    '/images/smartone3.jpg',
    '/images/nexgo1.jpg',
    '/images/nexgo2.jpg',
    '/images/nexgo3.jpg'
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const openModal = (index) => {
    setCurrentIndex(index);
    setIsModalOpen(true);
  };
  const closeModal = () => setIsModalOpen(false);
  const prevImage = () =>
    setCurrentIndex((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1));
  const nextImage = () =>
    setCurrentIndex((prev) => (prev === galleryImages.length - 1 ? 0 : prev + 1));

  return (
    <div className="flex flex-col space-y-16">
      {/* --- Hero bo‘limi --- */}
      <section className="relative h-screen bg-cover bg-center" style={{ backgroundImage: "url('https://i.ibb.co/LqCGM3p/main-photo.jpg')" }}>
        <div className="absolute inset-0 bg-black opacity-50" />
        <div className="relative container mx-auto h-full flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-xl sm:text-3xl text-5xl md:text-4xl lg:text-6xl font-extrabold text-white drop-shadow-lg font-techno">
            {displayedTitle}
            <span className="inline-block w-1 h-full bg-gray-100 animate-blink" />
          </h1>
          <p className="mt-4 text-xl md:text-2xl text-gray-100 drop-shadow-md max-w-2xl">
            {t('home.heroSubtitle', 'Sifatli, ishonchli va zamonaviy Onlayn NKT larni taqdim etamiz')}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href="/Products"
              className="bg-etmgreen text-white font-semibold py-3 px-8 rounded-full hover:bg-green-600 transition"
            >
              {t('home.ctaProducts', 'Mahsulotlar')}
            </a>
            <a
              href="/Services"
              className="bg-white text-etmgreen font-semibold py-3 px-8 rounded-full hover:bg-gray-100 transition"
            >
              {t('home.ctaServices', 'Xizmatlarimiz')}
            </a>
          </div>
        </div>
      </section>

      {/* --- Biz haqimizda bo‘limi --- */}
      <section className="bg-white py-16">
        <div className="container mx-auto px-4 md:flex md:items-center md:space-x-8">
          <div className="md:w-1/2 space-y-6">
            <h2 className="text-3xl font-bold text-etmgreen">
              {t('home.aboutTitle', 'Biz haqimizda')}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {t(
                'home.aboutText1',
                '“Navoi Kompyuter Spektr ETM” MCHJ  2002-yildan beri nazorat kassa  texnikalari (NKT) sohasida yetakchi hisoblanadi. Biz mijozlarimizga zamonaviy, ishonchli va qulay onlayn NKT lar  tizimlarini taqdim etib, biznesingiz samaradorligini oshirishga yordam beramiz. '
              )}
            </p>
            <p className="text-gray-700 leading-relaxed">
              {t(
                'home.aboutText2',
                'Hozirgi kunda 500 dan ortiq mijozimiz bor va ular orasida do‘konlar, oshxonalar,  restoranlar va supermarketlar mavjud.'
              )}
            </p>
            <p className="text-gray-700 leading-relaxed">
              {t(
                'home.aboutText3',
                'Biz Onlayn NKT larni ishga tushirish, texnik xizmat ko‘rsatish, xodimlarni o‘qitish va 24/7 davomida qo‘llab-quvvatlash xizmatlarini taklif qilamiz. Har bir mahsulotimizga 12 oylik rasmiy kafolat beriladi.'
              )}
            </p>
            <a
              href="/About"
              className="inline-block bg-etmgreen text-white font-semibold py-3 px-8 rounded-full hover:bg-green-600 transition"
            >
              {t('home.learnMore', 'Ko‘proq ma’lumot')}
            </a>
          </div>
          <div className="md:w-1/2 mt-8 md:mt-0">
            <img
              src="/images/about.jpg"
              alt="Biz haqimizda"
              className="w-full rounded-lg shadow-lg object-cover h-64 md:h-80"
            />
          </div>
        </div>
      </section>

      {/* --- Xizmatlar bo‘limi --- */}
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-etmgreen text-center mb-8">
            {t('home.servicesTitle', 'Asosiy Xizmatlarimiz')}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition text-center">
              <div className="flex items-center justify-center h-16 w-16 bg-etmgreen text-white rounded-full mb-4 mx-auto">
                <span className="text-2xl">🖥️</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">
                {t('home.service1Title', 'Ishga tushirish va Konfiguratsiya')}
              </h3>
              <p className="text-gray-600 text-sm">
                {t(
                  'home.service1Text',
                  'Onlayn NKT larini joyiga o‘rnatish, dasturiy ta’minotni sozlash va birinchi ishga tushirish.'
                )}
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition text-center">
              <div className="flex items-center justify-center h-16 w-16 bg-etmgreen text-white rounded-full mb-4 mx-auto">
                <span className="text-2xl">🔧</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">
                {t('home.service2Title', 'Texnik Xizmat')}
              </h3>
              <p className="text-gray-600 text-sm">
                {t(
                  'home.service2Text',
                  'Oylik texnik va dasturiy qo‘llab - quvvatlash'
                )}
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
              <div className="flex items-center justify-center h-16 w-16 bg-etmgreen text-white rounded-full mb-4 mx-auto">
                <span className="text-2xl">🎓</span>
              </div>
              <h3 className="text-xl font-semibold text-center mb-2">
                {t('services.trainingTitle', 'Xodimlarni o‘qitish')}
              </h3>
              <p className="text-gray-600 text-sm text-center">
                {t(
                  'services.trainingText',
                  'Onlayn NKT lardan maksimal manfaat olish uchun xodimlarga malakali trening va qo‘llanmalar berib borish.'
                )}
              </p>
            </div>
          </div>
          <div className="mt-8 text-center">
            <a
              href="/Services"
              className="inline-block bg-etmgreen text-white font-semibold py-3 px-8 rounded-full hover:bg-green-600 transition"
            >
              {t('home.viewAllServices', 'Barcha xizmatlar')}
            </a>
          </div>
        </div>
      </section>

      {/* --- Afzalliklar bo‘limi --- */}
      <section className="bg-white py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-etmgreen text-center mb-8">
            {t('home.featuresTitle', 'Nega Bizni Tanlashingiz Kerak')}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition text-center">
              <div className="flex items-center justify-center h-16 w-16 bg-etmgreen text-white rounded-full mb-4 mx-auto">
                <span className="text-2xl">🚀</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">
                {t('home.feature1Title', 'Tezkor Ishlash')}
              </h3>
              <p className="text-gray-600 text-sm">
                {t(
                  'home.feature1Text',
                  'Bizning Onalyn NKT larimiz yuqori tezlikda ishlaydi, chek bosish vaqtini minimallashtiradi.'
                )}
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition text-center">
              <div className="flex items-center justify-center h-16 w-16 bg-etmgreen text-white rounded-full mb-4 mx-auto">
                <span className="text-2xl">🔒</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">
                {t('home.feature2Title', 'Xavfsizlik')}
              </h3>
              <p className="text-gray-600 text-sm">
                {t(
                  'home.feature2Text',
                  'Ma’lumotlaringiz shifrlanadi va zamonaviy himoya standartlariga mos keladi.'
                )}
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition text-center">
              <div className="flex items-center justify-center h-16 w-16 bg-etmgreen text-white rounded-full mb-4 mx-auto">
                <span className="text-2xl">📈</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">
                {t('home.feature3Title', 'To‘liq Hisobotlar')}
              </h3>
              <p className="text-gray-600 text-sm">
                {t(
                  'home.feature3Text',
                  'Savdo statistikasi, tahlil va moliyaviy hisobotlarni real vaqt rejimida kuzatib boring.'
                )}
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition text-center">
              <div className="flex items-center justify-center h-16 w-16 bg-etmgreen text-white rounded-full mb-4 mx-auto">
                <span className="text-2xl">🤝</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">
                {t('home.feature4Title', 'Yaxshi Xizmat')}
              </h3>
              <p className="text-gray-600 text-sm">
                {t(
                  'home.feature4Text',
                  'O‘rnatish, trening, va 24/7 texnik qo‘llab-quvvatlash bo‘yicha doim yoningizdamiz.'
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* --- Fotogalereya bo‘limi --- */}
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-etmgreen mb-8">
            {t('home.galleryTitle', 'Fotogaleriya')}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {galleryImages.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`Galerii rasm ${index + 1}`}
                className="w-full h-60 object-cover rounded-lg shadow-lg cursor-pointer"
                onClick={() => openModal(index)}
              />
            ))}
          </div>
        </div>
      </section>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
          <div className="relative bg-transparent w-11/12 md:w-3/4 lg:w-1/2">
            <button
              className="absolute top-2 right-2 text-white text-3xl font-bold"
              onClick={closeModal}
            >
              &times;
            </button>
            <button
              className="absolute left-2 top-1/2 transform -translate-y-1/2 text-white text-4xl font-bold bg-black bg-opacity-50 rounded-full p-2"
              onClick={prevImage}
            >
              ‹
            </button>
            <button
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white text-4xl font-bold bg-black bg-opacity-50 rounded-full p-2"
              onClick={nextImage}
            >
              ›
            </button>
            <div className="overflow-hidden rounded-lg">
              <img
                src={galleryImages[currentIndex]}
                alt={`Katta rasm ${currentIndex + 1}`}
                className="w-full h-auto max-h-[80vh] object-contain mx-auto"
              />
            </div>
            <div className="mt-4 flex justify-center space-x-2 overflow-x-auto">
              {galleryImages.map((thumbSrc, idx) => (
                <img
                  key={idx}
                  src={thumbSrc}
                  alt={`Thumbnail ${idx + 1}`}
                  className={`w-16 h-10 object-cover rounded cursor-pointer transition-transform ${
                    idx === currentIndex ? 'ring-2 ring-etmgreen' : 'opacity-60 hover:opacity-100'
                  }`}
                  onClick={() => setCurrentIndex(idx)}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {/* --- CTA bo‘limi --- */}
      <section className="bg-gradient-to-r from-etmgreen to-sky text-white py-16">
        <div className="container mx-auto px-4 text-center space-y-6">
          <h2 className="text-3xl font-bold">
            {t('home.ctaTitle', 'Hozir biz bilan bog‘laning va yechimni tanlang!')}
          </h2>
          <p className="text-lg max-w-2xl mx-auto">
            {t(
              'home.ctaText',
              'Innovatsion onlayn kassa texnikalar va mukammal qo‘llab-quvvatlash xizmati orqali biznesingizni yangi bosqichga olib chiqing.'
            )}
          </p>
          <a
            href="/Contact"
            className="inline-block bg-white text-etmgreen font-semibold py-3 px-8 rounded-full hover:bg-gray-100 transition"
          >
            {t('home.ctaButton', 'Aloqa')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;
